import { makeShowMoralField } from '../../../../personType/logic/show';
export var showLogic = makeShowMoralField({});
export var makeShowLogic = makeShowMoralField;
